import React from 'react';

const CatalogPage = () => {
    return (
        <div className="pt-24 pb-16 px-10 container mx-auto">
            <h1 className="text-4xl font-bold text-center mb-8">Our Product Catalog</h1>
            <p className="text-center mb-10 text-gray-600">Download our latest product brochure below.</p>

            <div className="flex justify-center">
                <a
                    // Path change kiya: Sirf file ka naam
                    href="/rbm-catalogue.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-orange-600 text-white px-8 py-4 rounded-lg text-xl hover:bg-orange-700 transition"
                >
                    Download PDF Catalog
                </a>
            </div>
        </div>
    );
};

export default CatalogPage;